module.exports = __webpack_public_path__ + "img/jorify.1e3d8e1a.svg";